export default __webpack_public_path__ + "static/media/send.ae4d491b.svg";